module.exports = __webpack_public_path__ + "static/media/УОМШ-26 - 2_260927_143951.b9141562.pdf";